// extracted by mini-css-extract-plugin
export default {"primary":"herotext_primary__1tk31","hero":"herotext_hero__tSjJa"};